import { MarkdownContainer, Typography } from "@shared/ui.primitives";

import { FreeGiftOfferCard } from "../FreeGiftOfferCard/FreeGiftOfferCard";

import { container } from "./FreeGiftOfferSection.css";

import "@shared/ui.primitives/style.css";

export interface FreeGiftOfferCardProps {
  heading: string;
  imageUrl: string;
  imageAlt: string;
  franchiseName: string;
  productName: string;
  rating: number;
  ratingCount: number;
  subText?: string;
}

/**
 * Card component displaying a free gift offer with product image, rating, and details
 *
 * @param {Object} props - Props for the FreeGiftOfferCard component
 * @param {string} props.heading - Heading for the card
 * @param {string} props.imageUrl - URL for the product image
 * @param {string} props.imageAlt - Alt text for the product image
 * @param {string} props.franchiseName - Name of the franchise/brand
 * @param {string} props.productName - Name of the product
 * @param {number} props.rating - Product rating value (0-5)
 * @param {number} props.ratingCount - Number of reviews for the rating
 * @param {string} [props.subText] - Optional subtext for additional information
 * @return {JSX.Element} Rendered FreeGiftOfferCard component
 */
export const FreeGiftOfferSection: React.FC<FreeGiftOfferCardProps> = ({
  heading,
  imageUrl,
  imageAlt,
  franchiseName,
  productName,
  rating,
  ratingCount,
  subText
}) => {
  return (
    <div className={container}>
      <MarkdownContainer
        content={heading}
        tagOverrides={{
          span: {
            component: Typography,
            props: {
              as: "h4",
              variant: "subheader-6",
              colour: "primary-dark"
            }
          }
        }}
      />
      <FreeGiftOfferCard
        imageUrl={imageUrl}
        imageAlt={imageAlt}
        franchiseName={franchiseName}
        productName={productName}
        rating={rating}
        ratingCount={ratingCount}
      />

      {subText && (
        <MarkdownContainer
          content={subText}
          forceBlock
          tagOverrides={{
            p: {
              component: Typography,
              props: {
                as: "p",
                variant: "smallprint-md",
                colour: "primary-dark"
              }
            }
          }}
        />
      )}
    </div>
  );
};
